import { render, staticRenderFns } from "./LevTable.vue?vue&type=template&id=4238164f&scoped=true"
import script from "./LevTable.vue?vue&type=script&lang=js"
export * from "./LevTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238164f",
  null
  
)

export default component.exports